import { createSelector } from '@reduxjs/toolkit';
import { TypedUseQueryStateResult } from '@reduxjs/toolkit/dist/query/react';
import { MmmConfigDto } from '../models/mmm-config';

type GetMmmConfigSelectFromResultArg = TypedUseQueryStateResult<
  MmmConfigDto[],
  any,
  any
>;

export const selectAvailableModelRunDetails = createSelector(
  (res: GetMmmConfigSelectFromResultArg) => res.data,
  (_: GetMmmConfigSelectFromResultArg, isFetching: boolean) => isFetching,
  (configs: MmmConfigDto[] | undefined, isFetching) => {
    if (isFetching) return [];
    return (
      configs?.map((config) => ({
        targetDate: config.targetDate,
        modelRunName: config.modelRunName
      })) ?? []
    );
  }
);

export const selectAvailableSegments = createSelector(
  (res: GetMmmConfigSelectFromResultArg) => res.data,
  (_: GetMmmConfigSelectFromResultArg, isFetching: boolean) => isFetching,
  (configs: MmmConfigDto[] | undefined, isFetching) => {
    if (isFetching) return [];
    return configs?.map((config) => config.segmentKey) ?? [];
  }
);

export const selectAvailableTimeTypes = createSelector(
  (res: GetMmmConfigSelectFromResultArg) => res.data,
  (_: GetMmmConfigSelectFromResultArg, isFetching: boolean) => isFetching,
  (
    _: GetMmmConfigSelectFromResultArg,
    __: boolean,
    segmentKey: string | undefined
  ) => segmentKey,
  (
    configs: MmmConfigDto[] | undefined,
    isFetching: boolean,
    segmentKey: string | undefined
  ) => {
    if (isFetching) return [];
    if (!segmentKey) return [];
    const config = configs?.find((c) => c.segmentKey === segmentKey);
    return config ? config.availableTimeTypes : [];
  }
);

export const selectDefaultAvailableModelTypes = createSelector(
  (res: GetMmmConfigSelectFromResultArg) => res.data,
  (_: GetMmmConfigSelectFromResultArg, isFetching: boolean) => isFetching,
  (
    _: GetMmmConfigSelectFromResultArg,
    __: boolean,
    segmentKey: string | undefined
  ) => segmentKey,
  (
    configs: MmmConfigDto[] | undefined,
    isFetching: boolean,
    segmentKey: string | undefined
  ) => {
    if (isFetching) return [];
    if (!segmentKey) return [];
    const config = configs?.find((c) => c.segmentKey === segmentKey);
    return config ? config.availableModelTypes : [];
  }
);
